import { IHinhThucThanhToan } from "../../model/respone/category/IHinhThucThanhToan"
import { apiClient } from "../apiClient"

export const HINH_THUC_THANH_TOAN_API_RESOURCE = "hinh-thuc-thanh-toan"
export const hinhThucThanhToanApi = {
    SelectAll: () => apiClient.get(`${HINH_THUC_THANH_TOAN_API_RESOURCE}`),
    Insert: (payload: IHinhThucThanhToan) => apiClient.post(`${HINH_THUC_THANH_TOAN_API_RESOURCE}`,payload),
    Update: (payload: IHinhThucThanhToan) => apiClient.put(`${HINH_THUC_THANH_TOAN_API_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${HINH_THUC_THANH_TOAN_API_RESOURCE}/${id}`),
}